import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-customer-component',
  templateUrl: './error-customer-component.component.html',
  styleUrls: ['./error-customer-component.component.scss']
})
export class ErrorCustomerComponentComponent implements OnInit {
  @Input() viewCustomerErrorList;
  page = 1;
  pageSize = 10;
  constructor(public activeModal: NgbActiveModal, private router:Router) { }

  ngOnInit(): void {
    //this.viewDpErrorList;
  }
  closeModal(sendData) {
    this.activeModal.close(sendData);
    window.location.reload();
  }

}
